import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'bizflex-error-page-not-allowed',
  standalone: true,
  imports: [],
  templateUrl: './not-allowed.component.html',
  styleUrls: ['./not-allowed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAllowedComponent {
  @HostBinding('class') private readonly hostClass = 'portal-section text-center';
}
